import React from 'react';
import styled from 'styled-components';
import { TimeAgoRenderer, Body, FlexColumn, BodySemiBold } from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';

const Container = styled(FlexColumn)`
  margin-bottom: 10px;
  background: ${({ theme }) => theme.colors.grey1};
  padding: 5px;
  border-radius: 4px;
  justify-content: space-between;
  ${media.mobile`10px 10px 10px 20px`} .name {
    max-width: 350px;
  }
  gap: 5px;
`;

const TimeAgo = styled(Body)`
  span {
    color: ${({ theme }) => theme.colors.grey4};
    font-weight: 400 !important;
  }
`;

const CommentGeneralDetail = styled.div``;
const CommentHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const CommentText = styled(Body)`
  display: flex;
  gap: 4px;
  color: ${({ theme, severity }) =>
    severity === 2 ? theme.colors.redNegative : severity === 3 ? theme.colors.yellowPartially : 'inherit'};
`;

const CommentBoldText = styled(BodySemiBold)``;

const Comment = ({ type, comment, firstName, t, lastName, createdAt }) => {
  return (
    <Container className="employee-side-bar-comments">
      <CommentGeneralDetail>
        <CommentHeader>
          <CommentBoldText>{[firstName, lastName].filter((cur) => !!cur).join(' ')}</CommentBoldText>
          <TimeAgo>
            <TimeAgoRenderer rowData={{ createdAt }} dataKey="createdAt" disabledTooltip />
          </TimeAgo>
        </CommentHeader>
        {type && type.slug !== 'other' && <CommentText severity={type?.severity}>{t(type.slug)}</CommentText>}
      </CommentGeneralDetail>
      <CommentText>{comment}</CommentText>
    </Container>
  );
};

export default Comment;
